// Russian translations (Русский)
import type { TranslationKeys } from './en';

export const ru: TranslationKeys = {
  // Common
  common: {
    home: 'Главная',
    settings: 'Настройки',
    language: 'Язык',
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Настройки',
    home: 'Главная',
    howToPlay: 'Как Играть',
    pieceRules: 'Правила Фигур',
    language: 'Язык',
    manageSubscription: 'Управление Подпиской',
    gameHistory: 'История Игр',
    analytics: 'Аналитика',
    premiumAccount: 'Премиум Аккаунт',
    chatEnabled: 'Чат: Включен',
    chatDisabled: 'Чат: Выключен',
  },

  // Piece Rules
  pieceRules: {
    title: 'Правила Фигур',
    description: 'Изучите движение фигур',
    selectPiece: 'Выбрать Фигуру',
    selectedLabel: 'Выбрано:',
    statusLabel: 'Статус:',
    statusReady: 'Готово',
    statusViewing: 'Просмотр',
    movement: 'Движение',
    regularMovement: 'Обычное Движение',
    ability: 'Способность',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Движение',
    savage: 'Дикий',
    birdtype: 'Тип Птица',
    birdType: 'Тип Птица',
    wallBlock: 'Блок Стены',
    moveblocks: 'Блоки Движения',
    wallclimb: 'Лазанье по Стене',
    lilypad: 'Кувшинка',
    poisonous: 'Ядовитый',
    meadow: 'Луг',
    parasiticfungi: 'Паразитический Гриб',
    zombification: 'Зомбификация',
    fungi: 'Гриб',
    traverse: 'Пересечь',
    capture: 'Захватить',
    faint: 'Упасть в Обморок',
    leap: 'Прыжок',
    swing: 'Качели',
    consume: 'Поглотить',
    gamble: 'Азарт',
    entangle: 'Опутать',
    ink: 'Чернила',
    rotate: 'Повернуть',
    backstep: 'Шаг Назад',
    trample: 'Растоптать',
    charge: 'Рывок',
    lane: 'Полоса',
    snakestrike: 'Удар Змеи',
    shedskin: 'Сбросить Кожу',
    house: 'Дом',
    plant: 'Тип Растение',
    planttype: 'Тип Растение',
    capturehost: 'Захват Хозяина',
    contagion: 'Заражение',
    lonewolf: 'Одинокий Волк',
    hop: 'Прыг',
    decay: 'Разложение',
    slide: 'Скольжение',
    block: 'Блок',
    poison: 'Яд',
    infection: 'Инфекция',
    howl: 'Вой',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Медведь может двигаться на одну клетку в любом направлении, как король в шахматах',
    bearMovementPost: 'Он блокируется только дружественными фигурами (кроме Деревьев, Медведи могут взбираться на Деревья!)',
    bearSavage: 'Медведь может преодолеть защитные способности, такие как Блок Носорога',
    bearSavagePost: 'Используя Дикий, Медведь может захватить любую фигуру с любого направления, добавляя смертоносности',

    // Crane
    craneMovement: 'Журавль может двигаться на 1 или 2 клетки по любой прямой линии',
    craneMovementPost: 'Журавль может даже перелетать через другие фигуры!',
    craneBirdType: 'Фигуры типа птица не могут захватывать крупные или хищные фигуры',
    craneBirdTypePost: 'Это включает Дерево, Носорога, Медведя и Волка',

    // Frog
    frogMovement: 'Лягушка прыгает на 2 клетки по диагонали',
    frogMovementPost: 'Она не может прыгнуть только на одну',
    frogWallBlock: 'Если обычный путь Лягушки на 2 клетки заблокирован стеной или другой фигурой, она не может захватывать',
    frogWallBlockPost: 'Её обычное движение сокращается до 1 клетки по диагонали',
    frogWallClimb: 'Когда Лягушка находится на стене доски (Столбец A или E), она может двигаться вверх или вниз на одну клетку',
    frogWallClimbPost: 'Если только не заблокирована дружественной фигурой или Носорогом перед Лягушкой',
    frogLilypad: 'Если Лягушка еще не двигалась в игре, она может переместиться на любую из первых 3 горизонталей как мощная защитная способность',
    frogLilypadPost: 'Она может захватить любую обычную фигуру, используя Прыжок на Кувшинку, кроме Носорога на более высокой горизонтали',
    frogPoisonous: 'Когда любое животное захватывает фигуру Лягушки, вы становитесь отравленными!',
    frogPoisonousPost: 'Отравленная фигура пропускает свой следующий доступный ход, прежде чем восстановиться',

    // Fungi
    fungiMovement: 'Гриб может двигаться на одну клетку в любом направлении',
    fungiMovementPost: 'Он блокируется только союзными фигурами',
    fungiMeadow: 'Гриб уменьшает способность движения вражеской фигуры Дерева',
    fungiMeadowPost: 'Вражеская фигура Дерева не может двигаться в пределах 1 клетки от фигуры Гриба',
    fungiParasitic: 'Гриб может обездвижить вражескую фигуру Дерева',
    fungiParasiticPost: 'Если Гриб находится в пределах 1 клетки от вражеского Дерева, оно не может двигаться, пока Гриб не отойдет или не будет захвачен',
    fungiZombification: 'Гриб может зомбифицировать любую вражескую фигуру животного, которая его захватывает, позволяя контролировать вражеское животное в течение одного хода',
    fungiZombificationPost: 'Зомбифицированная фигура также считается фигурой Гриба на этот ход, даже если Гриб был вашим королем, игра не заканчивается до окончания этого хода',
    fungiFungi: 'Гриб',
    fungiFungiPost: 'Таким как яд, опутывание и вирусная инфекция, но не зомбификация, так как он может зомбифицировать других!',

    // Goat
    goatMovement: 'Коза может двигаться на одну клетку в любом направлении',
    goatMovementPost: 'Коза движется медленно, но имеет мощные способности',
    goatTraverse: 'Коза может пересекать любые другие связанные фигуры, чтобы создать массивный потенциал движения',
    goatTraversePost: 'Коза не может пересекать упавших в обморок Коз или Крошечные фигуры, такие как Вирус',
    goatCapture: 'Коза не может захватывать никаких Хищников',
    goatCapturePost: 'Таких как Медведь или Волк',
    goatFaint: 'Коза может упасть в обморок, чтобы избежать захвата, кроме крупных фигур, таких как Дерево и Носорог',
    goatFaintPost: 'В обмороке противники могут "стоять" на упавшей в обморок козе, чтобы остановить её движение',

    // Monkey
    monkeyMovement: 'Обезьяна может двигаться на одну клетку в любом направлении',
    monkeyMovementPost: 'Без других фигур для использования Обезьяна имеет ограниченное движение',
    monkeyLeap: 'Обезьяна, как в игре в шашки, может прыгать через другие фигуры по прямой линии для огромного потенциала движения',
    monkeyLeapPost: 'Но если прыгает через вражескую фигуру, Обезьяна должна бросить кубик, чтобы выжить в прыжке, 1/6 шанса захвата за каждого врага, через которого она прыгает!',
    monkeySwing: 'Если Обезьяна использует прыжок через Дерево, Обезьяна получает бонусный ход',
    monkeySwingPost: 'Использование качелей на дереве создает мощное синергетическое комбо между фигурами Обезьяны и Дерева',
    monkeyConsume: 'Обезьяна может поглотить фигуру Гриба для бонусного хода',
    monkeyConsumePost: 'Приводя к разрушительным комбинациям в сочетании с другими бонусными ходами',
    monkeyGamble: 'Помимо броска кубика для прыжка через врагов, Обезьяна должна рискнуть, чтобы захватить Медведя',
    monkeyGamblePost: 'Обезьяна должна выбросить 5 или 6 на 6-гранном кубике, чтобы захватить Медведя, или она будет захвачена сама',

    // Octopus
    octopusMovement: 'Осьминог движется на одну клетку в любом направлении',
    octopusCapture: 'Осьминог может захватывать только ортогонально',
    octopusCapturePost: 'Осьминог может захватывать или опутывать фигуры сложными способами, поэтому всегда проверяйте красные захваты и фиолетовые опутывания!',
    octopusEntangle: 'Осьминог может опутывать соседние вражеские фигуры, обездвиживая их, он может даже переместиться на клетку и опутать врагов!',
    octopusEntanglePost: 'Опутанные фигуры не могут двигаться, пока Осьминог не отойдет или не будет захвачен',
    octopusInk: 'Осьминог может использовать чернила для побега из опасных ситуаций, создавая до 3 теней',
    octopusInkPost: 'Запутывая врага и позволяя интересные приманочные и уклонительные игры',

    // Penguin
    penguinMovement: 'Пингвин скользит по прямой линии в установленном направлении, пока стена или фигура не заблокирует его движение',
    penguinMovementPost: 'После движения Пингвин в том же ходу может установить свое финальное направление',
    penguinRotate: 'В начале матча Пингвин смотрит вниз и должен повернуться, прежде чем сможет скользить, также известен как спящий',
    penguinRotatePost: 'Пингвин в любой позиции может выбрать поворот вместо движения',
    penguinBirdType: 'У Пингвина ограниченные способности захвата, как у Журавля, он не может захватывать крупные или хищные фигуры, такие как Дерево, Носорог, Медведь или Волк',
    penguinBirdTypePost: 'После захвата Пингвин может повернуться в любом направлении для стратегического позиционирования',

    // Rhino
    rhinoMovement: 'Носорог двигается на две клетки только вперед',
    rhinoMovementPost: 'Он не может двигаться только на 1 клетку',
    rhinoBackStep: 'Носорог может двигаться назад-влево или назад-вправо',
    rhinoCharge: 'Носорог один раз за игру может пройти одну дополнительную клетку вперед, используя свою способность рывка',
    rhinoChargePost: 'Приводя к разрушительному потенциалу движения и захвата',
    rhinoTrample: 'Носорог захватывает все фигуры на своем пути с помощью Растаптывания',
    rhinoTramplePost: 'Включая упавшую в обморок фигуру Козы',
    rhinoLane: 'Носорог может поменяться местами с другой союзной фигурой, позволяя стратегическую игру по полосам',
    rhinoLanePost: 'Но только если Носорог и союзная фигура оба не двигались',

    // Snake
    snakeMovement: 'Змея может двигаться на 2 клетки по любой прямой линии',
    snakeMovementPost: 'Змея двигается ровно на 2 клетки, если не заблокирована стеной или дружественной фигурой',
    snakeMoveBlocks: 'Когда заблокирована стеной или фигурой, которую не может захватить, движение Змеи сокращается до 1 клетки',
    snakeMoveBlocksPost: 'Она все еще может двигаться на две клетки, даже если есть промежуточная фигура',
    snakeStrike: 'Змея может ударить на 3 клетки вперед, если там есть вражеское животное',
    snakeStrikePost: 'Пока никакие промежуточные фигуры не блокируют её путь',
    snakeShedskin: 'Один раз за игру Змея может сбросить кожу и вернуться на первую горизонталь, если клетка свободна',
    snakeShedskinPost: 'Это возрождение дает Змее дополнительную жизнь в каждой игре',

    // Tree
    treeMovement: 'Дерево может двигаться на одну клетку вперед или на любую клетку в своей горизонтали из стороны в сторону',
    treeMovementPost: 'До тех пор, пока его путь не заблокирован',
    treeHouse: 'Дерево может укрывать другие фигуры, защищая их от врагов, которые не могут взбираться на Деревья. Может, фигуры могут взбираться, как Медведь, Журавль, Лягушка, Гриб, Коза, Обезьяна, Осьминог и Змея',
    treeHousePost: 'Когда фигура, которая может взобраться на дерево, атакует, она захватывает только укрытую фигуру, защищая Дерево',
    treeTrample: 'Дерево, как Носорог, захватывает все фигуры на клетке, когда движется',
    treeTramplePost: 'Это включает упавшую в обморок Козу',
    treePlant: 'Дерево - это растение, а не животное, поэтому оно невосприимчиво к нескольким эффектам',
    treePlantPost: 'Таким как яд, зомбификация, опутывание и вирусная инфекция!',

    // Virus
    virusMovement: 'Вирус может двигаться только на клетки, занятые животными, которые находятся на расстоянии двух клеток',
    virusMoveBlocks: 'Вирус может двигаться только на одну клетку, если он рядом со стеной',
    virusCaptureHost: 'Когда Вирус приземляется на (в) любую фигуру животного, он только заражает их, они все еще могут продолжать обычную игру, будучи зараженными',
    virusCaptureHostPost: 'Вирус захватывает фигуру только когда покидает зараженного хозяина',
    virusContagion: 'Вирус может быстро распространяться, заражая множество хозяев за один ход',
    virusContagionPost: 'Заражение позволяет Вирусу делать столько законных ходов, сколько он хочет в каждый ход',

    // Wolf
    wolfMovement: 'Волк может двигаться L-образно, как конь в шахматах',
    wolfMovementPost: 'Он не блокируется никакими другими фигурами',
    wolfLoneWolf: 'Волк',
    wolfLoneWolfPost: 'Волк также считает себя одиноким, когда у него все еще есть упавшая в обморок Коза или союзник вирус',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Перетаскивайте для исследования • Сжимайте для масштабирования',
    dragToExploreDesktop: '🖱️ Перетаскивайте для исследования • Прокручивайте для масштабирования',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Назад',
    next: 'Далее',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'ПЕСОЧНИЦА',
    description: 'Экспериментируйте и Практикуйтесь',
    mode: 'Режим:',
    modeValue: 'Песочница',
    status: 'Статус:',
    statusReady: 'Готово',
    clearBoard: 'Очистить Доску',
  },

  // Multiplayer
  multiplayer: {
    title: 'МУЛЬТИПЛЕЕР',
    description: 'Найдите свой матч и соревнуйтесь!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Калибровочные Матчи',
    matchProgress: 'Прогресс Матча',
    gamesCompleted: '{games} / 10 Игр Завершено',
    estimatedFinalRating: 'Предполагаемый Финальный Рейтинг',
    startingRating: 'Начальный рейтинг',
    matchesRemaining: '{matches} матчей осталось',
    findPlacementMatch: 'Найти Калибровочный Матч',

    // Matchmaking modes
    findMatch: 'Найти Матч',
    competitive: 'Соревновательный',
    competitiveDesc: 'Найдите противников близких к вашему рейтингу',
    quick: 'Быстрый',
    quickDesc: 'Найдите соревновательные матчи быстро',
    casual: 'Казуальный',
    casualDesc: 'Без рейтинга - играйте для удовольствия!',
    placement: 'Калибровка',
    placementDesc: 'Завершите 10 матчей для получения рейтинга',
    startSearch: 'Начать Поиск',

    // Searching
    searching: 'Поиск...',
    mode: 'Режим:',
    inQueue: 'В Очереди:',
    players: 'игрок',
    playersPlural: 'игроков',
    cancelSearch: 'Отменить Поиск',

    // Game info
    status: 'Статус:',
    ready: 'Готово',
    selectingKing: 'Выбор Короля',
    placingPieces: 'Расстановка Фигур',
    playing: 'Игра',
    gameType: 'Тип Игры:',
    opponent: 'Противник:',
    opponentElo: 'ELO Противника:',
    unranked: 'Без Рейтинга',

    // Piece placement
    dragPieces: 'Перетащите фигуры на доску',
    lightPieces: 'Светлые Фигуры (Вы)',
    darkPieces: 'Темные Фигуры (Вы)',

    // Waiting states
    waitingForOpponent: 'Ожидание Противника...',
    waitingForKing: 'Ожидание, пока противник выберет своего короля...',

    // Warnings
    invalidPlacement: 'Неверная Расстановка',
    lightTurn: 'Ход Светлого игрока!',
    darkTurn: 'Ход Темного игрока!',
    onlyLightPieces: 'Вы можете расставлять только светлые фигуры!',
    onlyDarkPieces: 'Вы можете расставлять только темные фигуры!',
    mustPlaceOnRow: 'Фигуры {color} должны быть размещены на ряду {row}!',

    // Chat
    chat: 'Чат',
    typeMessage: 'Введите сообщение...',
    send: 'Отправить',
  },

  // Main Page
  mainPage: {
    title: 'ЖИВОТНЫЕ ШАХМАТЫ',
    subtitle: 'Игра для людей',
    playersOnline: 'Игроков сейчас онлайн',
    placement: 'Калибровка',
    placementProgress: 'Калибровка',
    challengeAI: 'Вызов ИИ',
    multiplayer: 'Мультиплеер',
    sandbox: 'Песочница',
    tutorials: 'Обучение',
    shop: 'Магазин',
    collection: 'Коллекция',
    history: 'История',
    analytics: 'Аналитика',
    courses: 'Курсы',
    upgradeAccount: 'Улучшить аккаунт',
    signIn: 'Войти',
    playAsGuest: 'Играть Гостем',
    welcomeBack: 'С возвращением! Обычно вы играете как',

    // Learn the Pieces section
    learnThePieces: 'Изучите фигуры',

    // Learn the Rules section
    learnTheRules: 'Изучите Правила',
    premiseTitle: 'Концепция',
    premiseText: 'Zodiac - это альтернатива шахматам со СКРЫТЫМ королем из списка 13 фигур, выберите уникальный состав, а затем блефуйте своего противника, чтобы победить его на доске 5 на 8',
    selectionTitle: 'Выбор',
    selectionText: 'Чтобы начать игру, тайно выберите своего короля, затем расставьте свои 5 фигур поочередно с противником, чтобы создать одно из более чем 500 миллиардов начальных состояний.',
    objectiveTitle: 'Цель',
    objectiveText: 'Либо прочитайте своего противника, чтобы ЗАХВАТИТЬ его тайного короля, либо ДОВЕДИТЕ своего короля через доску, чтобы обеспечить победу!',
    competeTitle: 'Соревнуйтесь',
    competeText: 'Проверьте свои навыки в рейтинге, разработайте новые личные техники и стратегии, повышайте ранг, чтобы сразиться с лучшими!',
    fullRulesButton: 'Для полных официальных правил нажмите здесь',

    // FAQ section
    faqTitle: 'Часто Задаваемые Вопросы',
    faqQuestion1: 'Какая идея стоит за шахматами Zodiac?',
    faqAnswer1: 'Шахматы Zodiac были первоначально вдохновлены словами Бобби Фишера о его вдохновении для создания Chess960, мы хотели расширить идею борьбы с механическим запоминанием и прославления человеческой интуиции в невообразимой глубине!',
    faqQuestion2: 'Зачем нам нужна альтернатива шахматам',
    faqAnswer2: 'Не нужна! Zodiac не хочет отвлекать людей от игры в шахматы! Это другой вариант со своими сильными и слабыми сторонами, мы надеемся, что вы получите удовольствие от него и поможете нам адаптировать эту игру для оживления новых ходов',
    faqQuestion3: 'Как выиграть в Шахматах Zodiac?',
    faqAnswer3: 'Есть три способа выиграть: захватить скрытую фигуру короля вашего противника, довести своего собственного короля до противоположной стороны доски, или в матче с временным контролем, чтобы время вашего противника истекло',
    faqQuestion4: 'Это FAQ?',
    faqAnswer4: 'Да, вы можете посмотреть на любой из перечисленных вопросов в FAQ, и если вы хотите больше подробностей, вы можете нажать на вопросы, а затем прочитать следующие подробности, как эти подробности, которые вы читаете сейчас',
    faqQuestion5: 'Сколько длится типичная игра?',
    faqAnswer5: 'Каждая игра сильно отличается! Некоторые игры заканчиваются за 2 хода, а некоторые могут занять 30 минут, обычно мы находим их на отметке 5-15 минут!',
    faqQuestion6: 'Что происходит, если никто не может сделать легальный ход?',
    faqAnswer6: 'Если игрок не может сделать ни одного легального хода (пат), игра заканчивается вничью. Игра также может закончиться вничью через повторение (одно и то же состояние доски 3 раза) или по взаимному согласию между игроками!',

    // About section
    aboutButton: 'О нас',
    privacyPolicy: 'Политика Конфиденциальности',
    developerInterface: 'Интерфейс Разработчика',
  },

  // About Modal
  about: {
    title: 'О Zodiac',
    paragraph1: 'Zodiac - это настольная игра, похожая на шахматы, сочетающая элементы выбора фигур из игр, таких как LoL и DotA, с механиками блефа из покера или игр на социальную дедукцию.',
    paragraph2: 'Ранние версии игры были созданы в 2014 году под названием Shadow Chess. В 2018 году она была переработана, чтобы стать тем, что вы видите сегодня, включая состав забавных фигур со сбалансированными, но уникальными паттернами движения и способностями.',
    paragraph3: 'Наше видение - записывать все данные игрового процесса пользователей, чтобы продолжать развивать игру в попытке сохранить игровой процесс свежим, поощряя новые ходы.',
    paragraph4: 'С гигантским пространством поиска Zodiac, скрытой информацией и позициями открытия доски мы надеемся предотвратить доминирование ИИ и сохранить zodiac игрой для людей!',
  },

  // Privacy Policy
  privacy: {
    title: 'Политика Конфиденциальности',
    lastUpdated: 'Последнее Обновление',

    introduction: {
      title: 'Введение',
      p1: 'Добро пожаловать в Zodiac Chess ("мы", "наш" или "нас"). Мы стремимся защищать вашу конфиденциальность и обеспечивать безопасный и приятный игровой опыт. Эта Политика Конфиденциальности объясняет, как мы собираем, используем, раскрываем и защищаем вашу информацию, когда вы используете наш сайт и игру.',
      p2: 'Используя Zodiac Chess, вы соглашаетесь со сбором и использованием информации в соответствии с этой политикой. Если вы не согласны с нашими политиками и практиками, пожалуйста, не используйте наш сервис.',
      contact: 'Свяжитесь с нами:',
    },

    infoCollect: {
      title: 'Информация, Которую Мы Собираем',
      accountInfo: {
        title: '1. Информация Аккаунта',
        item1: 'Адрес Электронной Почты: Требуется для создания аккаунта и коммуникации',
        item2: 'Имя Пользователя: Ваше выбранное отображаемое имя',
        item3: 'Пароль: Зашифрован и безопасно хранится',
      },
      gameData: {
        title: '2. Игровые Данные',
        item1: 'Игровая Статистика: Победы, поражения, рейтинг ELO, прогресс калибровочных матчей',
        item2: 'Данные Игрового Процесса: Выборы фигур, сделанные ходы, использованные стратегии',
        item3: 'История Матчей: Записи сыгранных игр, встреченных противников',
        item4: 'Покупки в Игре: Косметические предметы и статус премиум-подписки',
      },
      technicalData: {
        title: '3. Технические Данные',
        item1: 'Информация об Устройстве: Тип браузера, операционная система',
        item2: 'Данные Использования: Посещенные страницы, затраченное время, использованные функции',
        item3: 'Локальное Хранилище: Языковые предпочтения, настройки UI, временное состояние игры',
      },
    },

    children: {
      title: 'Конфиденциальность Детей (Соответствие COPPA)',
      p1: 'Zodiac Chess разработан как семейная игра и подходит для игроков всех возрастов, включая детей. Мы проявляем особую осторожность для соблюдения Закона о Защите Конфиденциальности Детей в Интернете (COPPA).',
      p2: 'Для пользователей младше 13 лет: Мы рекомендуем детям использовать наш режим гостевой игры, который не требует создания аккаунта или сбора данных. Гостевые аккаунты не имеют доступа к функциям текстового чата, гарантируя, что дети не подвергаются общению с более широким интернетом. Если ребенок создает аккаунт, мы требуем согласия родителей перед сбором любой личной информации.',
      p3: 'Мы НЕ собираем, используем или сознательно передаем личную информацию детей младше 13 лет без проверенного согласия родителей.',
      p4: 'Безопасность Чата: Текстовый чат автоматически отключен для всех гостевых/временных аккаунтов. Владельцы стандартных аккаунтов имеют возможность отключить функцию чата в настройках своего аккаунта в любое время.',
      parentalRights: 'Родители имеют право:',
      right1: 'Просматривать личную информацию своих детей',
      right2: 'Запрашивать удаление данных своих детей',
      right3: 'Отказаться от дальнейшего сбора или использования информации своих детей',
      contactUs: 'Чтобы воспользоваться этими правами или если вы считаете, что ваш ребенок предоставил нам личную информацию, пожалуйста, немедленно свяжитесь с нами по адресу contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Как Мы Используем Вашу Информацию',
      item1: 'Предоставлять и улучшать наши игровые сервисы',
      item2: 'Подбирать вам подходящих противников на основе уровня навыков',
      item3: 'Отслеживать ваш прогресс, статистику и достижения',
      item4: 'Обрабатывать платежи за премиум-подписки и косметические предметы',
      item5: 'Отправлять важные объявления и обновления сервиса',
      item6: 'Анализировать игровые данные для улучшения баланса игры и функций',
    },

    thirdParty: {
      title: 'Сторонние Сервисы',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Мы используем Firebase для аутентификации, хранения базы данных и функциональности мультиплеера. Firebase может собирать определенные данные, как описано в их политике конфиденциальности.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Мы используем Stripe для обработки платежей за премиум-подписки и покупки в приложении. Stripe обрабатывает всю информацию о платежных картах - мы никогда не видим и не храним ваши полные платежные данные.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Наш сайт размещен на Netlify, который может собирать стандартные данные веб-хостинга, такие как IP-адреса и журналы доступа.',
      },
      adsense: {
        title: 'Google AdSense (Будущее)',
        description: 'Мы можем показывать рекламу через Google AdSense. Эти объявления могут использовать файлы cookie для персонализации. Для контента, направленного на детей, мы будем показывать только неперсонализированную рекламу в соответствии с COPPA.',
      },
      viewPolicy: 'Просмотреть их Политику Конфиденциальности',
    },

    cookies: {
      title: 'Файлы Cookie и Локальное Хранилище',
      description: 'Мы используем локальное хранилище браузера (похожее на файлы cookie) для улучшения вашего опыта:',
      item1: 'Языковое Предпочтение: Запоминание вашего выбранного языка',
      item2: 'Сессия Аккаунта: Сохранение вашего входа (работает с Firebase)',
      item3: 'Настройки Игры: Запоминание ваших предпочтений UI и настроек песочницы',
      item4: 'Рекламные Файлы Cookie: Если вы даете согласие, сторонние рекламные сервисы могут использовать файлы cookie для персонализации рекламы',
    },

    security: {
      title: 'Безопасность Данных',
      p1: 'Мы применяем соответствующие меры безопасности для защиты вашей информации:',
      item1: 'Шифрование Паролей: Все пароли зашифрованы с использованием отраслевых стандартных методов',
      item2: 'Безопасные Соединения: Шифрование HTTPS для всей передачи данных',
      item3: 'Правила Безопасности Firebase: Строгий контроль доступа к базе данных',
      p2: 'Однако ни один метод передачи через интернет не является на 100% безопасным. Хотя мы стремимся защитить ваши данные, мы не можем гарантировать абсолютную безопасность.',
    },

    retention: {
      title: 'Хранение Данных',
      p1: 'Мы храним ваши данные следующим образом:',
      item1: 'Активные Аккаунты: Данные хранятся, пока ваш аккаунт активен',
      item2: 'Неактивные Аккаунты: Если ваш аккаунт неактивен в течение 10 лет, мы можем удалить ваши данные',
    },

    rights: {
      title: 'Ваши Права на Конфиденциальность',
      description: 'В зависимости от вашего местоположения, вы можете иметь следующие права:',
      access: {
        title: 'Доступ:',
        description: 'Запросить копию ваших персональных данных',
      },
      correction: {
        title: 'Исправление:',
        description: 'Запросить исправления ваших данных',
      },
      deletion: {
        title: 'Удаление:',
        description: 'Запросить удаление вашего аккаунта и данных',
      },
      portability: {
        title: 'Портативность Данных:',
        description: 'Запросить ваши данные в переносимом формате',
      },
      optOut: {
        title: 'Отказ:',
        description: 'Отказаться от маркетинговых коммуникаций',
      },
      contact: 'Чтобы воспользоваться любым из этих прав, пожалуйста, свяжитесь с нами по адресу contact@zodiac-chess.com',
    },

    international: {
      title: 'Международные Пользователи',
      p1: 'Zodiac Chess управляется из Новой Зеландии. Если вы получаете доступ к нашему сервису за пределами Новой Зеландии, пожалуйста, имейте в виду, что ваша информация может быть передана, храниться и обрабатываться в Новой Зеландии и других странах, где работают наши поставщики услуг.',
      p2: 'Используя наш сервис, вы соглашаетесь на передачу вашей информации в страны за пределами вашей страны проживания, которые могут иметь другие законы о защите данных.',
    },

    changes: {
      title: 'Изменения в Этой Политике Конфиденциальности',
      description: 'Мы можем время от времени обновлять эту Политику Конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую Политику Конфиденциальности на этой странице и обновив дату "Последнее Обновление". Значительные изменения будут сообщаться по электронной почте или заметным уведомлением на нашем сайте.',
    },

    contact: {
      title: 'Свяжитесь с Нами',
      description: 'Если у вас есть какие-либо вопросы, опасения или запросы относительно этой Политики Конфиденциальности или наших практик работы с данными, пожалуйста, свяжитесь с нами:',
      email: 'Электронная почта:',
      company: 'Компания:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Условия использования',
    lastUpdated: 'Последнее обновление',
    back: 'Назад',
    viewPrivacyPolicy: 'Просмотреть Политику конфиденциальности',
    acknowledgment: 'Используя Zodiac Chess, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать настоящие Условия использования.',
    acceptance: {
      title: '1. Принятие условий',
      p1: 'Получая доступ и используя Zodiac Chess («Сервис»), вы принимаете и соглашаетесь соблюдать настоящие Условия использования. Если вы не согласны с этими условиями, пожалуйста, не используйте Сервис.',
      p2: 'Мы оставляем за собой право изменять эти условия в любое время. Продолжение использования Сервиса после изменений означает принятие изменённых условий.',
    },
    description: {
      title: '2. Описание сервиса',
      p1: 'Zodiac Chess — это онлайн стратегическая настольная игра с уникальными фигурами животных со специальными способностями. Сервис включает:',
      feature1: 'Одиночную игру против ИИ-противников',
      feature2: 'Многопользовательский подбор игроков и соревновательную игру',
      feature3: 'Интерактивные обучающие материалы и ресурсы',
      feature4: 'Создание аккаунта и отслеживание прогресса',
      feature5: 'Дополнительные функции премиум-подписки',
      feature6: 'Варианты косметической настройки',
    },
    accounts: {
      title: '3. Учётные записи пользователей',
      eligibility: {
        title: '3.1 Право на использование',
        p1: 'Для создания аккаунта вам должно быть не менее 13 лет. Пользователи младше 13 лет могут использовать гостевой режим под родительским контролем, но не могут создавать аккаунты.',
      },
      responsibilities: {
        title: '3.2 Безопасность аккаунта',
        p1: 'Вы несёте ответственность за:',
        item1: 'Сохранение конфиденциальности вашего пароля',
        item2: 'Все действия, происходящие под вашей учётной записью',
        item3: 'Немедленное уведомление нас о любом несанкционированном использовании',
        p2: 'Мы не несём ответственности за любые потери или ущерб, возникшие в результате несанкционированного доступа к аккаунту.',
      },
      prohibited: {
        title: '3.3 Запрещённые действия',
        p1: 'Вам ЗАПРЕЩЕНО:',
        item1: 'Делиться своим аккаунтом с другими',
        item2: 'Использовать несколько аккаунтов для манипуляции рейтингами',
        item3: 'Использовать ботов, скрипты или автоматизированные инструменты для игры',
        item4: 'Преследовать, оскорблять или угрожать другим игрокам',
        item5: 'Использовать баги или сбои для нечестного преимущества',
        item6: 'Осуществлять обратную разработку или пытаться получить доступ к нашему исходному коду',
        p2: 'Нарушение этих правил может привести к приостановке аккаунта или постоянной блокировке.',
      },
    },
    premium: {
      title: '4. Премиум-подписки',
      billing: {
        title: '4.1 Оплата',
        p1: 'Премиум-подписки обрабатываются через Stripe. Приобретая премиум-подписку, вы разрешаете нам регулярно списывать средства с вашего способа оплаты до отмены.',
        p2: 'Стоимость подписки:',
        item1: 'Месячный план: Списание ежемесячно в годовщину даты покупки',
        item2: 'Годовой план: Списание ежегодно в годовщину даты покупки',
        p3: 'Цены могут быть изменены с уведомлением активных подписчиков за 30 дней.',
      },
      cancellation: {
        title: '4.2 Отмена',
        p1: 'Вы можете отменить подписку в любое время через настройки аккаунта или связавшись со службой поддержки. Отмена вступает в силу в конце текущего расчётного периода.',
        p2: 'Вы сохраните премиум-функции до конца оплаченного периода даже после отмены.',
      },
      refunds: {
        title: '4.3 Возвраты',
        p1: 'Месячные подписки: Возврат за неполные месяцы не предусмотрен. Отмените в любое время, чтобы остановить будущие списания.',
        p2: 'Годовые подписки: Полный возврат при запросе в течение 7 дней с момента покупки. После 7 дней возврат на наше усмотрение.',
        p3: 'Косметические покупки: Как правило, не подлежат возврату. Свяжитесь со службой поддержки в исключительных случаях.',
      },
    },
    acceptable: {
      title: '5. Политика допустимого использования',
      p1: 'Вы соглашаетесь использовать Zodiac Chess уважительно и законно. Запрещённое поведение включает:',
      item1: 'Мошенничество, взлом или эксплуатацию игровых механик',
      item2: 'Преследование, разжигание ненависти или дискриминационные высказывания',
      item3: 'Спам, рекламу или навязывание',
      item4: 'Распространение неприемлемого контента (если чат или пользовательский контент включены)',
      item5: 'Выдавание себя за других пользователей или сотрудников',
      item6: 'Попытки нарушить работу или повредить Сервис',
      p2: 'Мы оставляем за собой право расследовать нарушения и принимать соответствующие меры, включая закрытие аккаунта и сообщение в органы власти при необходимости.',
    },
    intellectual: {
      title: '6. Права интеллектуальной собственности',
      ownership: {
        title: '6.1 Наш контент',
        p1: 'Весь игровой контент, включая, но не ограничиваясь, игровые механики, художественное оформление, анимации, звуковые эффекты, код и дизайн, принадлежат Animal Chess Limited или нашим лицензиарам.',
        p2: 'Вам предоставляется ограниченная, неисключительная, непередаваемая лицензия на использование Сервиса исключительно в личных развлекательных целях.',
      },
      userContent: {
        title: '6.2 Пользовательский контент',
        p1: 'Отправляя контент (например, сообщения чата, имена пользователей или информацию профиля), вы предоставляете нам всемирную безвозмездную лицензию на использование, отображение и распространение этого контента в связи с Сервисом.',
        p2: 'Вы заявляете, что владеете или имеете необходимые права на любой контент, который вы отправляете.',
      },
    },
    disclaimers: {
      title: '7. Отказ от ответственности и ограничения',
      p1: 'СЕРВИС ПРЕДОСТАВЛЯЕТСЯ «КАК ЕСТЬ» БЕЗ КАКИХ-ЛИБО ГАРАНТИЙ, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ.',
      p2: 'Мы не гарантируем, что:',
      item1: 'Сервис будет работать бесперебойно и без ошибок',
      item2: 'Дефекты будут исправлены',
      item3: 'Сервис свободен от вирусов или вредоносных компонентов',
      item4: 'Результаты использования Сервиса оправдают ваши ожидания',
      p3: 'В МАКСИМАЛЬНОЙ СТЕПЕНИ, РАЗРЕШЁННОЙ ЗАКОНОМ, МЫ НЕ НЕСЁМ ОТВЕТСТВЕННОСТИ ЗА:',
      item5: 'Любые косвенные, случайные или последующие убытки',
      item6: 'Потерю прибыли, данных или деловой репутации',
      item7: 'Перебои в работе сервиса или потерю данных',
      item8: 'Убытки, превышающие сумму, которую вы заплатили нам за последние 12 месяцев',
    },
    privacy: {
      title: '8. Конфиденциальность',
      p1: 'Использование Сервиса также регулируется нашей Политикой конфиденциальности, которая объясняет, как мы собираем, используем и защищаем вашу личную информацию.',
      p2: 'Используя Сервис, вы соглашаетесь с нашими практиками обработки данных, описанными в Политике конфиденциальности.',
    },
    changes: {
      title: '9. Изменения условий',
      p1: 'Мы оставляем за собой право изменять настоящие Условия использования в любое время. Мы уведомим пользователей о существенных изменениях через:',
      item1: 'Уведомление по электронной почте для зарегистрированных пользователей',
      item2: 'Заметное объявление на сайте',
      item3: 'Обновлённую дату «Последнее обновление» в верхней части этой страницы',
      p2: 'Продолжение использования Сервиса после изменений означает принятие изменённых условий.',
    },
    governing: {
      title: '10. Применимое право',
      p1: 'Настоящие Условия использования регулируются законодательством Новой Зеландии без учёта принципов коллизионного права.',
      p2: 'Любые споры, возникающие из этих условий или использования Сервиса, будут разрешаться в судах Новой Зеландии.',
    },
    contact: {
      title: '11. Контактная информация',
      p1: 'По вопросам, проблемам или для поддержки относительно настоящих Условий использования:',
      email: 'Эл. почта:',
      company: 'Компания:',
      address: 'Адрес:',
    },
    severability: {
      title: '12. Делимость положений',
      p1: 'Если какое-либо положение настоящих условий будет признано неисполнимым или недействительным, это положение будет ограничено или исключено в минимально необходимой степени, а остальные положения сохранят полную силу и действие.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Политика использования файлов Cookie',
    lastUpdated: 'Последнее обновление',
    browserInstructions: {
      chrome: 'Настройки → Конфиденциальность и безопасность → Файлы cookie',
      firefox: 'Настройки → Приватность и защита → Куки и данные сайтов',
      safari: 'Настройки → Конфиденциальность → Файлы cookie и данные веб-сайтов',
      edge: 'Настройки → Конфиденциальность, поиск и службы → Файлы cookie',
    },
    cookieTable: {
      name: 'Название Cookie',
      purpose: 'Назначение',
      duration: 'Срок действия',
      type: 'Тип',
    },
    relatedPolicies: {
      title: 'Связанные политики',
      description: 'Для получения дополнительной информации о том, как мы обрабатываем ваши данные, см.:',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
    },

    introduction: {
      title: 'Введение',
      p1: 'Настоящая Политика использования файлов Cookie объясняет, как Zodiac Chess («мы» или «нас») использует файлы cookie и аналогичные технологии при посещении вами нашего веб-сайта.',
      p2: 'Используя наш веб-сайт, вы соглашаетесь на использование нами файлов cookie в соответствии с настоящей политикой. Если вы не согласны, отключите файлы cookie в настройках браузера или не используйте наш веб-сайт.',
    },
    what: {
      title: 'Что такое Cookie?',
      p1: 'Файлы cookie — это небольшие текстовые файлы, которые размещаются на вашем устройстве (компьютере, смартфоне, планшете) при посещении веб-сайта. Они широко используются для обеспечения эффективной работы веб-сайтов и предоставления информации владельцам сайтов.',
      p2: 'Файлы cookie служат различным целям, включая запоминание ваших предпочтений, анализ использования сайта и включение определённых функций.',
    },
    types: {
      title: 'Типы используемых нами Cookie',
      necessary: {
        title: '1. Необходимые Cookie',
        description: 'Эти файлы cookie необходимы для правильной работы веб-сайта. Без этих файлов cookie запрошенные вами услуги не могут быть предоставлены.',
        examples: 'Примеры:',
        item1: 'Cookie аутентификации — поддерживают вашу авторизацию в аккаунте',
        item2: 'Cookie безопасности — защищают от мошеннической деятельности',
        item3: 'Сеансовые cookie — сохраняют состояние игры во время сеанса',
        item4: 'Настройки согласия на cookie — запоминают ваш выбор в отношении cookie',
      },
      analytics: {
        title: '2. Аналитические Cookie',
        description: 'Эти файлы cookie помогают нам понять, как посетители взаимодействуют с нашим веб-сайтом, собирая анонимную информацию о посещениях страниц, проведённом времени и используемых функциях.',
        provider: 'Поставщик: Firebase Analytics (Google)',
        purpose: 'Назначение:',
        item1: 'Измерение трафика веб-сайта и вовлечённости пользователей',
        item2: 'Определение популярных функций и страниц',
        item3: 'Понимание демографии пользователей (возрастная группа, общее местоположение)',
        item4: 'Улучшение производительности веб-сайта и пользовательского опыта',
      },
      advertising: {
        title: '3. Рекламные Cookie',
        description: 'Эти файлы cookie используются для показа релевантной для вас рекламы. Они также ограничивают количество показов рекламы и помогают измерять эффективность рекламных кампаний.',
        provider: 'Поставщик: Google AdSense',
        purpose: 'Назначение:',
        item1: 'Показ персонализированной рекламы на основе ваших интересов',
        item2: 'Измерение эффективности и вовлечённости рекламы',
        item3: 'Предотвращение слишком частого показа одной и той же рекламы',
        note: 'Примечание: Премиум-подписчики никогда не видят рекламу, независимо от настроек cookie.',
      },
    },
    firstThird: {
      title: 'Собственные Cookie vs Cookie третьих сторон',
      firstParty: {
        title: 'Собственные Cookie',
        description: 'Это файлы cookie, устанавливаемые непосредственно Zodiac Chess. Мы используем их для основной функциональности сайта, аутентификации и запоминания ваших предпочтений.',
      },
      thirdParty: {
        title: 'Cookie третьих сторон',
        description: 'Это файлы cookie, устанавливаемые внешними сервисами, которые мы используем, такими как Google Analytics и Google AdSense. Cookie третьих сторон подчиняются политикам конфиденциальности этих поставщиков.',
      },
    },
    specific: {
      title: 'Конкретные используемые нами Cookie',
      tableHeader: 'Ниже приведён подробный список файлов cookie, используемых на нашем веб-сайте:',
    },
    control: {
      title: 'Как управлять Cookie',
      consent: {
        title: '1. Баннер согласия на Cookie',
        description: 'При первом посещении нашего веб-сайта вы увидите баннер согласия на cookie. Вы можете:',
        item1: 'Принять все — разрешить все cookie (необходимые, аналитические и рекламные)',
        item2: 'Отклонить необязательные — разрешить только необходимые cookie (без аналитики или рекламы)',
        item3: 'Настроить — выбрать, какие именно типы cookie вы хотите разрешить',
      },
      browser: {
        title: '2. Настройки браузера',
        description: 'Большинство веб-браузеров позволяют управлять файлами cookie через свои настройки. Вы можете:',
        item1: 'Блокировать все файлы cookie',
        item2: 'Принимать только собственные cookie',
        item3: 'Удалять cookie после каждого сеанса просмотра',
        item4: 'Просматривать и удалять отдельные cookie',
        links: 'Вот ссылки на управление cookie для популярных браузеров:',
      },
      optOut: {
        title: '3. Инструменты отказа',
        description: 'Для рекламных cookie вы можете отказаться от персонализированной рекламы:',
        googleLink: 'Настройки рекламы Google',
        googleDesc: ' — управление персонализированной рекламой Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' — отказ от рекламы на основе интересов',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' — инструмент отказа для ЕС',
      },
    },
    impact: {
      title: 'Последствия отключения Cookie',
      p1: 'Если вы отключите или откажетесь от файлов cookie, обратите внимание:',
      item1: 'Некоторые части веб-сайта могут работать неправильно',
      item2: 'Вам может потребоваться повторно вводить свои предпочтения при каждом посещении',
      item3: 'Вы можете быть выведены из своей учётной записи',
      item4: 'Необходимые cookie требуются для работы сайта — их отключение помешает вам использовать основные функции',
    },
    updates: {
      title: 'Обновления настоящей Политики Cookie',
      p1: 'Мы можем время от времени обновлять настоящую Политику Cookie для отражения изменений в наших практиках или по юридическим, нормативным или операционным причинам.',
      p2: 'Мы уведомим вас о существенных изменениях, обновив дату «Последнее обновление» в верхней части этой страницы. Пожалуйста, периодически просматривайте эту политику.',
    },
    contact: {
      title: 'Свяжитесь с нами',
      p1: 'Если у вас есть вопросы об использовании нами файлов cookie или настоящей Политике Cookie, свяжитесь с нами:',
      email: 'Эл. почта:',
      company: 'Компания:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Пингвин',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Медведь',
    Crane: 'Журавль',
    Frog: 'Лягушка',
    Fungi: 'Гриб',
    Goat: 'Коза',
    Monkey: 'Обезьяна',
    Octopus: 'Осьминог',
    Penguin: 'Пингвин',
    Rhino: 'Носорог',
    Snake: 'Змея',
    Tree: 'Дерево',
    Virus: 'Вирус',
    Wolf: 'Волк',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
